// extracted by mini-css-extract-plugin
module.exports = {"label":"ResetPasswordForm_label__1ZbPR","input":"ResetPasswordForm_input__2zDbu","email":"ResetPasswordForm_email__1zri6","textInfo":"ResetPasswordForm_textInfo__fwTnA"};